<template>
    <v-snackbar
        transition="scroll-x-reverse-transition"
        app
        right
        vertical
        :timeout="timeout"
        :color="color"
        :value="value"
    >
        <v-icon left small v-text="icon"></v-icon>
        <span v-html="text"></span>
        <template v-slot:action="{ attrs }">
            <v-btn small text v-bind="attrs" @click="$emit('close-snackbar')">Close</v-btn>
        </template>
    </v-snackbar>
</template>

<script>

/**
 * @module Snackbar
 * 
 * @vue-prop {string} text='' - Set message
 * @vue-prop {string} [color=primary] - Set color
 * @vue-prop {boolean} value=false - Controls whether the component is visible or hidden
 * @vue-prop {number|string} [timeout=4000] - Time (in milliseconds) to wait until snackbar is automatically hidden, use -1 to keep open indefinitely
 * @vue-prop {string} [icon=mdi-alert-circle-outline] - Set icon
 */

export default {
    name: "Snackbar",
    props: {
        text: {
            required: true,
            type: String,
        },
        color: {
            default: "primary",
            type: String,
        },
        value: {
            required: true,
            type: Boolean,
        },
        timeout: {
            default: 4000,
            type: [Number, String],
        },
        icon: {
            default: "mdi-alert-circle-outline",
            type: String
        }
    },
};
</script>